export const AI_AWARENESS_PASSING_ANSWER_COUNT = 4;
export const HIPAA_PASSING_ANSWER_COUNT = 4;
